import React from 'react';

import classNames from 'classnames';

import classes from './InitialScanIndicator.module.scss';

type InitialScanIndicatorProps = {
  isCompleted: boolean;
  hide?: boolean;
};

const InitialScanIndicator = ({
  isCompleted,
  hide = false,
}: InitialScanIndicatorProps) => {
  const dotClass = classNames(classes.dot, isCompleted ? classes.green : classes.red);

  if (hide) {
    return null;
  }

  return <span className={dotClass} aria-hidden />;
};

export { InitialScanIndicator };
